<template>
  <div class="header">
    <div class="header__logo" @click="home()">
      <svg xmlns="http://www.w3.org/2000/svg" width="106" height="20" viewBox="0 0 106 20">
        <g>
          <path
            d="M11.704 13.677c0 1.858-.33 3.05-1.01 4C9.763 18.97 7.938 20 5.687 20 2.29 20 .679 17.899.272 16.141H3.28c.233.526.66.91 1.126 1.152.543.303 1.106.384 1.436.384 1.553 0 3.241-1.111 3.241-3.414v-.95c-.543 1.01-1.688 2.02-3.532 2.02C2.426 15.333 0 12.848 0 9.373c0-3.696 2.543-6.04 5.551-6.04 1.572 0 2.911.748 3.532 1.859V3.697h2.62v9.98zM2.6 9.354c0 1.98 1.358 3.494 3.26 3.494.971 0 1.747-.363 2.31-.97.583-.605.912-1.434.932-2.403 0-.869-.252-1.778-.796-2.445C7.802 6.343 6.987 5.9 5.842 5.9c-1.766 0-3.26 1.414-3.26 3.455H2.6zM13.376 3.676h2.259V5.17c.444-1.01 1.262-1.816 2.757-1.837v2.725h-.107c-1.672 0-2.526.888-2.526 2.846V15h-2.383V3.676zM20.063 0h2.926v2.361h-2.926V0zm0 3.869h2.926V15h-2.926V3.869zM36.783 10.647C36.146 13.098 33.937 15 31.051 15c-3.543 0-5.972-2.706-5.972-5.843 0-3.255 2.548-5.824 5.872-5.824 2.807 0 5.195 1.745 5.832 4.432h-2.727c-.458-1.157-1.552-1.98-3.005-1.98-.976-.02-1.732.313-2.389.94-.577.608-.915 1.49-.915 2.451 0 1.98 1.413 3.393 3.304 3.393 1.672 0 2.607-.98 3.005-1.883h2.727v-.039zM37.619 3.676h2.259V5.17c.427-1.01 1.245-1.816 2.757-1.837v2.725h-.107c-1.672 0-2.526.888-2.526 2.846V15H37.62V3.676zM68.55 14.667h-2.58v-1.589C65.279 14.353 63.854 15 62.334 15c-3.465 0-5.486-2.745-5.486-5.843 0-3.47 2.463-5.824 5.486-5.824 1.963 0 3.176 1.06 3.638 1.942V3.667h2.58v11zm-9.124-5.451c0 1.372.962 3.353 3.292 3.353 1.443 0 2.387-.765 2.868-1.765.25-.47.385-1 .423-1.55.02-.529-.077-1.058-.288-1.548-.443-1.04-1.463-1.941-3.003-1.941-2.118 0-3.292 1.725-3.292 3.45zM46.987 10.04c.12 1.764 1.708 2.744 3.217 2.725 1.29 0 2.164-.589 2.68-1.49h2.74c-.535 1.215-1.31 2.137-2.243 2.764-.933.647-2.025.961-3.197.961-3.435 0-5.877-2.745-5.877-5.804 0-3.118 2.482-5.863 5.837-5.863 1.668 0 3.118.628 4.17 1.687 1.35 1.372 1.867 3.098 1.648 5.039h-8.975v-.02zm6.354-2c-.099-1.04-1.23-2.51-3.177-2.491-1.965 0-3.038 1.412-3.137 2.49h6.314zM71.312 5.913L69.386 5.913 69.386 3.869 71.312 3.869 71.312 0 74.086 0 74.086 3.869 76.074 3.869 76.074 5.913 74.086 5.913 74.086 15 71.312 15zM77.746 0h2.926v2.361h-2.926V0zm0 3.869h2.926V15h-2.926V3.869zM88.33 15L85.532 15 81.09 3.333 84.059 3.333 86.942 11.485 89.825 3.333 92.794 3.333zM95.479 10.04c.12 1.764 1.71 2.744 3.222 2.725 1.293 0 2.168-.589 2.685-1.49h2.745c-.537 1.215-1.313 2.137-2.248 2.764-.935.647-2.029.961-3.202.961-3.44 0-5.887-2.745-5.887-5.804 0-3.118 2.486-5.863 5.847-5.863 1.67 0 3.123.628 4.157 1.687 1.353 1.372 1.87 3.098 1.65 5.039h-8.97v-.02zm6.344-2c-.099-1.04-1.213-2.51-3.162-2.491-1.969 0-3.043 1.412-3.162 2.49h6.324z"
          />
        </g>
      </svg>
    </div>
    <div class="header__properties">
      <breadcrumb />
      <div class="header__logout">
        <div class="header__logout__user">{{user}}</div>
        <button class="header__logout__button" @click="logout"></button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      user: this.$store.getters.getUser
    };
  },
  methods: {
    logout: async function() {
      await this.$store
        .dispatch("logout")
        .then(() => this.$router.push({ name: "login" }));
    },
    home: function() {
      this.$router.push({ name: "formlist" });
    }
  },
  computed: {
    tabs() {
      let _tabs = this.$router.options.routes.filter(item => {
        if (typeof item.children == "undefined") return false;
        return item.children.some(itm => itm.name == this.$route.name);
      })[0].children;

      return _tabs;
    }
  }
};
</script>